var InteractiveLayer = {
  props: {
    interactive: {
      type: Boolean,
      default: true
    },
    bubblingMouseEvents: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted () {
    this.interactiveLayerOptions = {
      interactive: this.interactive,
      bubblingMouseEvents: this.bubblingMouseEvents
    };
  }
};

export default InteractiveLayer;



//////////////////
// WEBPACK FOOTER
// ./~/vue2-leaflet/dist/mixins/InteractiveLayer.js
// module id = 1698
// module chunks = 1